import InvoiceCard from "./invoice-card";
import { useTranslation } from "react-i18next";
import Loading from "@/components/custom/loading";
import { Invoice } from "@/lib/types";
import { useGetCurrencies } from "@/services/queries/currency";
import { useMemo, useState } from "react";
import { RiRefreshLine } from "@remixicon/react";

const INITIAL_INVOICE_COUNT = 3;

const Invoices = ({
  invoices,
  isPending,
  refetch,
}: {
  invoices: Invoice[];
  isPending: boolean;
  refetch: () => void;
}) => {
  const { t, i18n } = useTranslation();
  const [showAll, setShowAll] = useState(false);
  const { data: currenciesData } = useGetCurrencies();

  const displayedInvoices = showAll
    ? invoices
    : invoices.slice(0, INITIAL_INVOICE_COUNT);
  const hasMore = invoices.length > INITIAL_INVOICE_COUNT;

  const currencies = useMemo(() => {
    return currenciesData?.value;
  }, [currenciesData]);

  return (
    <div className="flex flex-col items-center justify-center px-5">
      <div className="flex w-full flex-row items-center justify-between">
        <h2 className="w-full text-start text-[15px] font-semibold leading-[15px] tracking-wide text-white">
          {t("title.invoices").toLocaleUpperCase(i18n.language)}
        </h2>
        <button onClick={() => refetch()} className="text-white">
          <RiRefreshLine size={18} />
        </button>
      </div>
      <div className="mt-5 flex w-full flex-col items-center justify-center gap-[10px]">
        {isPending ? (
          <Loading className="mt-10" />
        ) : invoices.length > 0 ? (
          <>
            {displayedInvoices.map((invoice) => (
              <InvoiceCard
                key={invoice.id}
                currencies={currencies}
                invoice={invoice}
              />
            ))}
            {hasMore && !showAll && (
              <button
                type="button"
                onClick={() => setShowAll(true)}
                className="w-full rounded-md border border-white/30 bg-white/10 py-2 text-sm font-medium text-white"
                data-testid="show-more-invoices"
              >
                {t("navigation.more")}
              </button>
            )}
            {hasMore && showAll && (
              <button
                type="button"
                onClick={() => setShowAll(false)}
                className="w-full rounded-md border border-white/30 bg-white/10 py-2 text-sm font-medium text-white"
                data-testid="show-less-invoices"
              >
                {t("navigation.less")}
              </button>
            )}
          </>
        ) : (
          <div className="mt-10 flex w-full flex-col items-center justify-center gap-[10px]">
            <p className="text-white">{t("label.no_invoices_found")}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Invoices;
